import { Dayjs } from 'dayjs'
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs'
import generatePicker from 'antd/es/date-picker/generatePicker/generateRangePicker'
import 'antd/es/date-picker/style'

const RangePickerCustom = generatePicker<Dayjs>(dayjsGenerateConfig)

export default RangePickerCustom
